import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ApiSuccess,
  AiProviderSettingInput,
  AiProviderSettingView,
  AiProviderTestResult,
} from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'ai-provider'];

export function useAiProviderSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<AiProviderSettingView> => {
      const res = await apiClient.get<ApiSuccess<AiProviderSettingView>>('/settings/ai-provider');
      return res.data.data;
    },
  });
}

export function useUpdateAiProvider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: AiProviderSettingInput): Promise<AiProviderSettingView> => {
      const res = await apiClient.put<ApiSuccess<AiProviderSettingView>>('/settings/ai-provider', input);
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useTestAiProvider() {
  return useMutation({
    mutationFn: async (): Promise<AiProviderTestResult> => {
      const res = await apiClient.post<ApiSuccess<AiProviderTestResult>>('/settings/ai-provider/test');
      return res.data.data;
    },
  });
}
